import styled from 'styled-components/macro';

export const StyledParticipationBudget = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${({ theme }) => theme.headerHeight}px);

  .prize-logo {
    display: flex;
    justify-content: center;
    align-items: end;
    height: 100%;
    margin-bottom: 4px;

    img {
      height: 44px;
      width: 44px;
    }
  }
`;

export const StyledAwardTooltipContent = styled.p`
  margin: 0;
`;
